<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <users-password
        v-if="passwordShow"
        :user-id="Number(userData().id)"
        :user-password-sidebar-active.sync="userPasswordSidebarActive"
      />
      <notification-dropdown />
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData().name }}
            </p>
            <span class="user-status">{{ (userData().role) == 'admin' ? 'Administrador' : 'Vendedor' }} </span>
          </div>
          <b-avatar
            size="40"
            variant="secondary"
            class="badge-minimal"
          />
        </template>
        <!-- <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="config()"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Configuración</span>
        </b-dropdown-item> -->
        <b-dropdown-item
          v-if="userData().role == 'vendor'"
          link-class="d-flex align-items-center"
          @click="changePassword()"
        >
          <feather-icon
            size="16"
            icon="LockIcon"
            class="mr-50"
          />
          <span style="white-space: nowrap;">Cambiar contraseña</span>
        </b-dropdown-item>
        <b-dropdown-divider v-if="userData().role == 'vendor'" />
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout()"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Salir</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import axios from '@axios'
import UsersPassword from '@/views/system/users/UsersPassword.vue'
import NotificationDropdown from '@/@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    // Navbar Components
    // DarkToggler,
    UsersPassword,
    NotificationDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      userPasswordSidebarActive: false,
      passwordShow: false,
    }
  },

  methods: {
    logout() {
      axios
        .post('system/logout')
        .then(response => {
          if (response.data.res) {
            localStorage.removeItem('DuttonAuthToken')
            this.$router.push({ name: 'login' })
          } else {
            throw (response)
          }
        })
        .catch(error => {
          this.showErrors(error)
        })
    },
    config() {
      this.$router.push({ name: 'user-settings' })
    },

    changePassword() {
      this.passwordShow = true
      this.userPasswordSidebarActive = true
    },

    makeToast(variant = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      })
    },

    userData() {
      return JSON.parse(localStorage.getItem('DuttonAuthUser'))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .dropdown-user .dropdown-menu {
  min-width: 200px !important;
  width: auto !important;
}
</style>
